/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatMoney } from "../functions/format-money.js";

const __vue_script__ = {
  props: ["errors", "requestZipCode", "currency", "hideInstallments"],
  data() {
    return {
      form: {
        zipcode: window.localStorage.getItem("address_zipcode") || "",
        address: window.localStorage.getItem("address_address") || "",
        number: window.localStorage.getItem("address_number") || "",
        complement: window.localStorage.getItem("address_complement") || "",
        neighborhood: window.localStorage.getItem("address_neighborhood") || "",
        state: window.localStorage.getItem("address_state") || "",
        city: window.localStorage.getItem("address_city") || "",
        installments: window.product.order_installment === "desc" ? window.product.billet_installments : 1
      }
    }
  },
  watch: {
    'form.zipcode'(val) {
      if (val.length === 8) {
        this.searchCep();
      }
    },
    'form.installments'(val){
        this.$emit('change', val)
    }
  },
  computed: {
    showInstallments() {
      return !this.hideInstallments && window.product.billet_installments && window.product.billet_installments > 1
    },
    installments() {
      if (!this.showInstallments) {
        return [];
      }

      var decSep = this.currency.prefix === "R$" ? ',' : '.';
      var thouSep = this.currency.prefix === "R$" ? '.' : ',';

      var installments = window.product.installments_billet;

      var result = [];
      var hasInterest = !window.product.is_tax_to_producer;
      for (var i in installments) {
        if (!this.showAmount) { 
          var value = installments[i];
        } else {
          var value = installments[i] * this.form.amount / installments[1];
        }
        result.push({ id: i, name: `${i} x ${this.currency.prefix} ${formatMoney(value * this.currency.value, 2, decSep, thouSep)}${i > 1 && hasInterest ? '*' : ''}` });
      }

      if (window.product.order_installment === "desc") {
        return result.reverse();
      }

      return result;
    }
  },
  methods: {
    save() {
      window.localStorage.setItem("address_zipcode", this.form.zipcode);
      window.localStorage.setItem("address_address", this.form.address);
      window.localStorage.setItem("address_number", this.form.number);
      window.localStorage.setItem("address_complement", this.form.complement);
      window.localStorage.setItem("address_neighborhood", this.form.neighborhood);
      window.localStorage.setItem("address_state", this.form.state);
      window.localStorage.setItem("address_city", this.form.city);
    },
    searchCep() {
      if (!this.form.zipcode.trim) return;
      this.searchingZipcode = true;
      
      window.$.getJSON(
        `https://viacep.com.br/ws/${this.form.zipcode}/json/?callback=?`,
        (data) => {
          if (!("erro" in data)) {
            this.form.address = data.logradouro;
            this.form.neighborhood = data.bairro;
            this.form.city = data.localidade;
            this.form.state = data.uf;
            this.form.country = "Brasil";
          }
        }
      ).always(() => {
        this.searchingZipcode = false;
      });
    }
  },
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-billet" },
    [
      _c("div", { staticClass: "form-row" }, [
        _c(
          "div",
          { staticClass: "col-lg-6" },
          [
            _c("form-group", {
              attrs: {
                required: "",
                label: "CEP",
                placeholder: "Ex: 12345-678",
                errors: _vm.errors.zipcode,
                id: "zipcode",
                type: "tel",
                mask: "#####-###",
              },
              model: {
                value: _vm.form.zipcode,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "zipcode", $$v)
                },
                expression: "form.zipcode",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-lg-6" },
          [
            _c("form-group", {
              attrs: {
                required: "",
                label: "Endereço",
                placeholder: "Ex: Rua A",
                readonly: _vm.requestZipCode,
                errors: _vm.errors.address,
                id: "address",
              },
              model: {
                value: _vm.form.address,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "address", $$v)
                },
                expression: "form.address",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _c(
          "div",
          { staticClass: "col-lg-6" },
          [
            _c("form-group", {
              attrs: {
                required: "",
                label: "Número",
                placeholder: "Ex: 2212",
                errors: _vm.errors.number,
                id: "number",
                type: "tel",
                mask: "######",
              },
              model: {
                value: _vm.form.number,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "number", $$v)
                },
                expression: "form.number",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-lg-6" },
          [
            _c("form-group", {
              attrs: {
                label: "Complemento (opcional)",
                placeholder: "Ex: 30 andar, sala 30024",
                errors: _vm.errors.complement,
                id: "complement",
              },
              model: {
                value: _vm.form.complement,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "complement", $$v)
                },
                expression: "form.complement",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _c(
          "div",
          { staticClass: "col-lg-6" },
          [
            _c("form-group", {
              attrs: {
                required: "",
                label: "Bairro",
                placeholder: "Ex: Jardins",
                readonly: _vm.requestZipCode,
                errors: _vm.errors.neighborhood,
                id: "neighborhood",
              },
              model: {
                value: _vm.form.neighborhood,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "neighborhood", $$v)
                },
                expression: "form.neighborhood",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-lg-2" },
          [
            _c("form-group", {
              attrs: {
                required: "",
                label: "Estado",
                placeholder: "Ex: SP",
                readonly: _vm.requestZipCode,
                errors: _vm.errors.state,
                mask: "AA",
                masked: "",
                id: "state",
              },
              model: {
                value: _vm.form.state,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "state", $$v)
                },
                expression: "form.state",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-lg-4" },
          [
            _c("form-group", {
              attrs: {
                required: "",
                label: "Cidade",
                placeholder: "Ex: São Paulo",
                readonly: _vm.requestZipCode,
                errors: _vm.errors.city,
                id: "city",
              },
              model: {
                value: _vm.form.city,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "city", $$v)
                },
                expression: "form.city",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.showInstallments
        ? _c("form-group", {
            attrs: {
              label: "Opções de parcelamento",
              errors: _vm.errors.installments,
              id: "installments",
              select: true,
              options: _vm.installments,
            },
            model: {
              value: _vm.form.installments,
              callback: function ($$v) {
                _vm.$set(_vm.form, "installments", $$v)
              },
              expression: "form.installments",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/components/form-billet.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__